import { switchAnatomy } from '@chakra-ui/anatomy';
import {
  createMultiStyleConfigHelpers,
  cssVar,
} from '@chakra-ui/styled-system';

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(switchAnatomy.keys);

const $trackBg = cssVar('switch-track-bg');
const $trackBgSelected = cssVar('switch-track-bg-selected');
const $thumbBg = cssVar('switch-thumb-bg');

const baseStyle = definePartsStyle(() => ({
  container: {
    // Container for the switch
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed',
    },
  },
  track: {
    bg: $trackBg.reference,
    _checked: {
      bg: $trackBgSelected.reference,
    },
    _dark: {
      [$trackBg.variable]: 'colors.switch.bg',
      [$trackBgSelected.variable]: 'colors.switch.bg-selected',
    },
  },
  thumb: {
    bg: $thumbBg.reference,
    _dark: {
      [$thumbBg.variable]: 'colors.switch.icon',
    },
  },
}));

export const switchTheme = defineMultiStyleConfig({
  baseStyle,
});
